import { findModuleDetailsByExport } from '../webpack';
const [mod, panelSection] = findModuleDetailsByExport((e) => e.toString()?.includes('.PanelSection'));
/** @component React Components */
export const PanelSection = panelSection;
/** @component React Components */
export const PanelSectionRow = Object.values(mod).filter((exp) => !exp?.toString()?.includes('.PanelSection'))[0];
